import * as styles from "./ParagraphCAQ.module.scss";

import { graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet-async";
import CommonQuestion from "../../../components/CommonQuestion";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

interface ParagraphCAQProps {
	sectionHeading?: string;
	jumpLinksTitle?: string;
	commonQuestions: {
		question: string;
		jumpLinksQuestionTitle?: string;
		answer: string;
	}[];
}
export const getParagraphCAQProps = ({
	field_section_heading,
	field_jump_links_title,
	relationships: { field_content },
}: Queries.ParagraphCAQDataFragment): ParagraphCAQProps => ({
	sectionHeading: field_section_heading,
	jumpLinksTitle: field_jump_links_title,
	commonQuestions: field_content.map((commonQuestion) => ({
		question: commonQuestion.title,
		jumpLinksQuestionTitle: commonQuestion.field_jump_links_title,
		answer: commonQuestion.field_answer.value,
	})),
});

export const ParagraphCAQ: React.FC<ParagraphCAQProps> = ({
	sectionHeading,
	jumpLinksTitle,
	commonQuestions,
}) => {
	const schema = {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: [
			commonQuestions.map((commonQuestion) => ({
				"@type": "Question",
				name: `${commonQuestion.question}`,
				acceptedAnswer: {
					"@type": "Answer",
					text: `${commonQuestion.answer}`,
				},
			})),
		],
	};

	return (
		<>
			<Helmet>
				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>

			<WrappedSection sectionColour={Colours.WHITE} sectionName="ParagraphCAQ">
				<div className={styles.paragraphcaq}>
					{sectionHeading && (
						<span className={styles.caqheading}>
							{jumpLinksTitle ? (
								<h2 data-jumplinkstitle={jumpLinksTitle}>{sectionHeading}</h2>
							) : (
								<h2>{sectionHeading}</h2>
							)}
						</span>
					)}
					<div className={styles.cards}>
						{commonQuestions.map((commonQuestion, i) => (
							<CommonQuestion
								key={commonQuestion.answer}
								isFirst={i === 0}
								question={commonQuestion.question}
								answer={commonQuestion.answer}
								isRTE={true}
								jumpLinksQuestionTitle={commonQuestion.jumpLinksQuestionTitle}
							/>
						))}
					</div>
				</div>
			</WrappedSection>
		</>
	);
};

export default ParagraphCAQ;

export const fragment = graphql`
    fragment ParagraphCAQData on paragraph__commonly_asked_question_section {
        __typename
        id
        field_section_heading
		field_jump_links_title
        relationships {
            field_content {
                title
				field_jump_links_title
                field_answer {
                    value
                }
            }
        }
    }
`;
